import { FC, useMemo, useState } from 'react'

import useProductPage from 'src/hooks/useProductPage'
import { AppMenuSavedDashboardInterface } from 'src/types/AppMenuInterface'
import { ReactCallBackFunction } from 'src/types/CallbackFunction'
import { isTrueOrUndefinedFn } from 'src/utils/booleanUtils'
import { getSubProductLinkFn } from 'src/utils/linkUtils'
import InputCompletion from '../../atoms/InputCompletion'
import PanelInfo from '../../atoms/PanelInfo'
import SidebarProductDashboard from '../../organisms/Sidebar/SidebarProducts/SidebarProductDashboard'

interface PageHeaderListDashboardsPopupProps {
  dashboards: AppMenuSavedDashboardInterface[]
  setIsFocused: ReactCallBackFunction<boolean>
}

const PageHeaderListDashboardsPopup: FC<PageHeaderListDashboardsPopupProps> = ({
  dashboards,
  setIsFocused,
}) => {
  const [search, setSearch] = useState('')
  const { code, product, program } = useProductPage()
  const filteredDashboards = useMemo(() => {
    return dashboards.filter(dashboard =>
      dashboard.name.toLowerCase().includes(search.toLowerCase()),
    )
  }, [dashboards, search])

  const subProductLink = getSubProductLinkFn({
    productCode: product,
    subProductCode: code,
    programId: program?.toString(),
  })

  return (
    <div>
      <div className="sticky top-0 z-1 bg-white pt-2 pb-1">
        <InputCompletion
          inputValue={search}
          onClear={() => setSearch('')}
          placeHolder="Search"
          onChange={e => setSearch(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
      </div>
      <div className="mt-1">
        {!filteredDashboards.length && <PanelInfo label="No matching results" />}
        {filteredDashboards.map(dashboard => (
          <SidebarProductDashboard
            key={dashboard.id}
            dashboard={dashboard}
            subProductCode={code}
            link={subProductLink}
            className="h-[25px] min-w-auto pl-4"
            hasAccess={isTrueOrUndefinedFn(dashboard?.has_access)}
            rightIconClassName="ml-auto!"
            isOnModal
            programId={program?.toString()}
          />
        ))}
      </div>
    </div>
  )
}

export default PageHeaderListDashboardsPopup
